<template>
<div>
    <form-errors :errors="formErrors" v-if="!hideFormErrors" />

    <form-input label="Address 1" v-model="formData.address_1" :errors="errors.address_1" type="text" :maxlength="50" />
    <form-input label="Address 2 (Optional)" v-model="formData.address_2" :errors="errors.address_2" type="text" :maxlength="50" />
    <form-input label="City" v-model="formData.city" :errors="errors.city" type="text" :maxlength="50" />

    <div class="form-row">
        <div class="col-6">
            <form-input label="State" v-model="formData.state" :errors="errors.state" type="select" :options="stateOptions"/>
        </div>
        <div class="col-6">
            <form-input label="Zip Code" :maxlength="5" v-model="formData.postal_code" :errors="errors.postal_code" type="text" inputmode="tel" />
        </div>
    </div>

    <div class="form-row">
        <div class="col-6">
            <form-input label="Phone Number" v-model="formData.phone" :errors="errors.phone" type="phone" inputmode="tel"/>
        </div>
    </div>

    <form-input label="Use a different mailing address?" type="checkbox" v-model="formData.use_mailing_address" class="mb-2"/>

    <template v-if="formData.use_mailing_address">
        <h5 class="mt-4 mb-2">Mailing Address</h5>
        <form-input label="Address 1" v-model="formData.mailing_address_1" :errors="errors.mailing_address_1" type="text" :maxlength="50" />
        <form-input label="Address 2 (Optional)" v-model="formData.mailing_address_2" :errors="errors.mailing_address_2" type="text" :maxlength="50" />
        <form-input label="City" v-model="formData.mailing_city" :errors="errors.mailing_city" type="text" :maxlength="50" />
        <div class="form-row">
            <div class="col-6">
                <form-input label="State" v-model="formData.mailing_state" :errors="errors.mailing_state" type="select" :options="stateOptions"/>
            </div>
            <div class="col-6">
                <form-input label="Zip Code" :maxlength="5" v-model="formData.mailing_postal_code" :errors="errors.mailing_postal_code" type="text" />
            </div>
        </div>
    </template>
</div>
</template>

<script>
import FormInput from '@/components/FormInput'
import FormErrors from '@/components/FormErrors'
import FormMixin from '@/mixins/Form'
import states from '@/states'

export default {
    mixins: [FormMixin],
    components: { FormInput, FormErrors },
    props: {
        employerHire: { required: false, default: null },
        client: { required: true },
        hideFormErrors: { required: false, default: false },
    },
    computed: {
        stateOptions() {
            return states.map((s) => ({ text: s.name.toUpperCase(), value: s.abbreviation }))
        },
    },
    watch: {
        client() { this.reset() },
        employerHire() { this.reset() },
    },
    data() {
        return {
            formRules: {
                address_1: { presence: { allowEmpty: false } },
                city: { presence: { allowEmpty: false } },
                state: { presence: { allowEmpty: false } },
                postal_code: { presence: { allowEmpty: false } },
                phone: { presence: { allowEmpty: false }, ten_digit_phone: true },
                mailing_address_1: { presence: { allowEmpty: false } },
                mailing_city: { presence: { allowEmpty: false } },
                mailing_state: { presence: { allowEmpty: false } },
                mailing_postal_code: { presence: { allowEmpty: false } },
            },
            formLabels: {
                postal_code: 'Zip Code',
                phone: 'Phone Number',
            },
            formData: this.makeFormData(),
        }
    },
    methods: {
        makeFormData() {
            const eh = this.employerHire
            return {
                address_1: eh?.address_1 || '',
                address_2: eh?.address_2 || '',
                city: eh?.city || '',
                state: eh?.state || '',
                postal_code: eh?.postal_code || '',
                phone: eh?.phone || '',
                use_mailing_address: eh?.use_mailing_address || false,
                mailing_address_1: eh?.mailing_address_1 || '',
                mailing_address_2: eh?.mailing_address_2 || '',
                mailing_city: eh?.mailing_city || '',
                mailing_state: eh?.mailing_state || '',
                mailing_postal_code: eh?.mailing_postal_code || '',
            }
        },
        onSubmit() {
            let validateFields = ['address_1', 'city', 'state', 'postal_code', 'phone']
            if (this.formData.use_mailing_address) {
                validateFields = validateFields.concat(['mailing_address_1', 'mailing_city', 'mailing_state', 'mailing_postal_code'])
            }
            if (!this.validate(validateFields)) {
                return
            }
            this.$emit('updated', this.getFormData())
        },
        reset() {
            this.formErrors = []
            FormMixin.methods.reset.call(this)
        },
    },
}
</script>
